import React, {useEffect, useState} from 'react'
import Layout from '../../components/common/pageLayout'
import CreateForm from '../../components/FAT/createForm'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { toast } from 'react-toastify'
import {v3_create_fat, v3_fat_documents, v3_update_fat} from '../../actions/v3/fat'

const Index = (props) => {
    const location = useLocation();
    const { projectId, data } = location.state;
    const [documents, setDocuments] = useState([])

    console.log(data)

    useEffect(() => {
        console.log('calling')
        v3_fat_documents(data.ID).then((res) => {
            setDocuments(res.result.documents)
        })
    }, [])

    const onSubmit = (model) => {
        v3_update_fat({ ...model, id: data.ID }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)

                props.history.push({
                    pathname: constant.Authedcomponent.fatProject.url,
                    state: {
                        projectId
                    }
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }
    console.log(documents)

    return (
        <Layout title='Update FAT'>
            <CreateForm
                data={data}
                documents = {documents}
                onSubmit={onSubmit}
                projectId={projectId}
            />
        </Layout>
    )
}

export default Index